import { render } from "./Operation.vue?vue&type=template&id=7570d6e4&scoped=true"
import script from "./Operation.vue?vue&type=script&lang=js"
export * from "./Operation.vue?vue&type=script&lang=js"

import "./Operation.vue?vue&type=style&index=0&id=7570d6e4&lang=less&scoped=true"

import exportComponent from "G:\\小程序\\OT ASAR\\vue后台\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7570d6e4"]])

export default __exports__